var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShareBorderThin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2546 9.37266C20.7094 9.39092 20.5328 9.83513 20.5328 10.4636V20.0636H1.4V10.4636C1.4 9.83513 1.31937 9.37266 0.690912 9.37266C0.145457 9.37266 0 9.83513 0 10.4636L0.0909119 20.0636C0.0909119 21.111 0.352566 21.4636 1.4 21.4636H20.5328C21.5803 21.4636 22 21.111 22 20.0636V10.4636C22 9.83513 21.8909 9.35134 21.2546 9.37266Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4853 0.736077C11.219 0.46981 10.7873 0.46981 10.5211 0.736077L6.43017 4.82699C6.1639 5.09326 6.1639 5.52496 6.43017 5.79123C6.69644 6.05749 7.12814 6.05749 7.39441 5.79123L10.3678 2.81439V16.3441C10.3678 16.7114 10.6655 17.0091 11.0328 17.0091C11.4 17.0091 11.6978 16.7114 11.6978 16.3441V2.86474L14.612 5.79123C14.8783 6.05749 15.31 6.05749 15.5762 5.79123C15.8425 5.52496 15.8425 5.09326 15.5762 4.82699L11.4853 0.736077Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareBorderThin);
export default __webpack_public_path__ + "static/media/icShareBorderThin.568e909c7fba3589bd0fdde2cc8988c6.svg";
export { ForwardRef as ReactComponent };